'use client';
import React from 'react';
import { Placeholder, Col, Row } from 'react-bootstrap';

export const SearchResultLoading = () => {
  return (
    <Row>
      <Col md={3}>
        <Placeholder
          xs={12}
          style={{ height: '170px', marginBottom: '20px' }}
        />
        <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
      </Col>
      <Col md={3}>
        <Placeholder
          xs={12}
          style={{ height: '170px', marginBottom: '20px' }}
        />
        <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
      </Col>
      <Col md={3}>
        <Placeholder
          xs={12}
          style={{ height: '170px', marginBottom: '20px' }}
        />
        <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
      </Col>
      <Col md={3}>
        <Placeholder
          xs={12}
          style={{ height: '170px', marginBottom: '20px' }}
        />
        <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
      </Col>
      <Col md={3}>
        <Placeholder
          xs={12}
          style={{ height: '170px', marginBottom: '20px' }}
        />
        <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
      </Col>
    </Row>
  );
};
export default SearchResultLoading;
